import { CardViewModule } from './../card-view/card-view.module';
import { IntlInputModule } from '../intl-input/intl-input.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectFormComponent } from './components/connect-form/connect-form.component';
import { InputModule } from '../input/input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CaptchaModule } from '../captcha/captcha.module';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ConnectFormComponentV2 } from './components/connect-form-v2/connect-form-v2.component';
import { PhoneNumberInputV2Component } from 'src/app/core/phone-number-input-v2/phone-number-input-v2.component';

@NgModule({
  declarations: [ConnectFormComponent, ConnectFormComponentV2],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputModule,
    IntlInputModule,
    CardViewModule,
    CaptchaModule,
    CaptchaInputModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatIconModule,
    PhoneNumberInputV2Component
  ],
  exports: [ConnectFormComponent, ConnectFormComponentV2]
})
export class ConnectFormModule { }
